import { Fragment } from 'react';
import { c } from '../../../utils/tailwind-merge';
import type { KeyboardShortcutProps } from './KeyboardShortcut.types';

const THIN_SPACE = '\u2009';

export const KeyboardShortcut = ({
  keys,
  className = '',
  'aria-hidden': ariaHidden,
}: KeyboardShortcutProps) => (
  <kbd
    aria-hidden={ariaHidden}
    className={c(
      'inline-flex items-center rounded-md border border-grey-600 bg-black px-1.5 py-0.5 font-sans text-xs font-medium leading-4 text-grey-200',
      className
    )}
  >
    {keys.map((key, index) => (
      <Fragment key={key}>
        {index > 0 &&
          (key.length > 1 || keys[index - 1].length > 1) &&
          THIN_SPACE}
        <kbd className="font-[inherit]">{key}</kbd>
      </Fragment>
    ))}
  </kbd>
);
